import React, { useEffect, useState } from 'react';
const slides = [{
  id: 1,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vrxhN9bAXyngomE7kp3Sug/Slide-Sturny-Schifferer.jpg',
  alt: 'Die beiden Therapeutinnen Eva Schifferer und Angelika Sturny'
}, {
  id: 2,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fCd93y8e6f5At65u5aYMDn/3-Slide.jpg',
  alt: 'Therapeutische Arbeit mit Notizzetteln zu Verständnis, Vertrauen und Toleranz'
}, {
  id: 3,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5m7YxQt3NpcS9oPb6uGKXu/1-Slide.jpg',
  alt: 'Dekorative gestreifte Kugeln auf einem Holztablett'
}];
export function Slideshow() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };
  return <div className="relative w-full h-[600px] overflow-hidden" data-id="element-229">
      {slides.map((slide, index) => <div key={slide.id} className={`absolute top-0 left-0 w-full h-full transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-230">
          <img src={slide.image} alt={slide.alt} className="w-full h-full object-cover" data-id="element-231" />
          <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-232"></div>
          {/* Title and subtitle overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-end px-6 md:px-12 pb-24" data-id="element-233">
            <div className="max-w-5xl mx-auto text-center" data-id="element-234">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-8 drop-shadow-lg" data-id="element-235">
                Psychologische Praxis
              </h1>
              <p className="text-xl md:text-2xl text-white max-w-3xl mx-auto drop-shadow-md" data-id="element-236">
                Wir begleiten Menschen in Veränderungs-, Belastungs- und
                Entwicklungsphasen – mit Respekt, Klarheit und Wertschätzung.
              </p>
            </div>
          </div>
        </div>)}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-3" data-id="element-237">
        {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-4 h-4 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'} transition-all duration-300`} aria-label={`Gehe zu Slide ${index + 1}`} data-id="element-238"></button>)}
      </div>
    </div>;
}